// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import {
  createNewConversation,
  createNewMessage,
  getListConversation,
  getListMessage,
} from '~/thunks/conversation/conversationThunk';
import { RootState } from '~/utils/redux/store';

export interface ConversationState {
  tempIdSendFile?: string;
  typeFileLoading?: string;
  isRefreshConversationList: boolean;
}

const initialState: ConversationState = {
  tempIdSendFile: EMPTY_STRING,
  typeFileLoading: EMPTY_STRING,
  isRefreshConversationList: false,
};

const conversationSlice = createSlice({
  name: 'conversation',
  initialState: initialState,
  reducers: {
    setTempIdFile(state, action) {
      const { tempIdSendFile, typeFileLoading } = action.payload;

      state.tempIdSendFile = tempIdSendFile;
      state.typeFileLoading = typeFileLoading;
    },
    setRefreshConversationList(state, action) {
      state.isRefreshConversationList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list conversation
    builder
      .addCase(getListConversation.pending, (_state) => {})
      .addCase(getListConversation.fulfilled, (_state) => {})
      .addCase(getListConversation.rejected, (_state) => {});

    // POST: Create new message
    builder
      .addCase(createNewMessage.pending, (_state) => {})
      .addCase(createNewMessage.fulfilled, (_state) => {})
      .addCase(createNewMessage.rejected, (_state) => {});

    // POST: Create new conversation
    builder
      .addCase(createNewConversation.pending, (_state) => {})
      .addCase(createNewConversation.fulfilled, (_state) => {})
      .addCase(createNewConversation.rejected, (_state) => {});

    // GET: Get list message
    builder
      .addCase(getListMessage.pending, (_state) => {})
      .addCase(getListMessage.fulfilled, (_state) => {})
      .addCase(getListMessage.rejected, (_state) => {});
  },
});

// Actions
export const conversationActions = conversationSlice.actions;

// Selectors
export const selectIsRefreshConversationList = (state: RootState) =>
  state.conversation.isRefreshConversationList;

// Reducer
const conversationReducer = conversationSlice.reducer;
export default conversationReducer;
